import React from 'react';
import './HelpButtons.css';

interface HelpButtonsProps {
  items: boolean[];
  onUseHelpItem: (itemIndex: number) => void;
}

const HELP_ICON_URL = "/phone.svg";
const FIFTY_FIFTY_HELP_ICON_URL = "/fifty-fifty.svg";
const AUDIENCE_HELP_ICON_URL = "/twitch.svg";
const SKIP_HELP_ICON_URL = "/change.svg";

const HelpButtonsComponent: React.FC<HelpButtonsProps> = ({ items, onUseHelpItem }) => {
  return (
    <div id="helps-container" className="w-100 d-flex justify-content-center p-4">
      <div id="helps" className="d-flex gap-4">
        {[
          { icon: HELP_ICON_URL, label: 'Llamada' },
          { icon: FIFTY_FIFTY_HELP_ICON_URL, label: '50/50' },
          { icon: AUDIENCE_HELP_ICON_URL, label: 'Twitch' },
          { icon: SKIP_HELP_ICON_URL, label: 'Cambio' }
        ].map((help, idx) => (
          <button
            key={idx}
            disabled={!items[idx]}
            className={`help-button ${!items[idx] ? 'opacity-20' : 'hover-glow'}`}
            onClick={() => onUseHelpItem(idx)}
            aria-label={`Usar comodín de ${help.label}`}
            title={`Usar comodín de ${help.label}`}
          >
            <img alt="" src={help.icon} className="help-button__icon" aria-hidden="true" />
          </button>
        ))}
      </div>
    </div>
  );
};

export const HelpButtons = React.memo(HelpButtonsComponent);
